import eventhub from './eventhub';
import slick from './slick';

export default {
    init() {
        eventhub.init();
        slick.init();
    },
};
